export default __webpack_public_path__ + "images/f009894f3ca5266874d8b565ba9bacfb.svg";